export default __webpack_public_path__ + "static/media/green-arrow-up.6a2b9cc0.svg";